import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content"]
  static values = { selected: String }

  connect() {
    this.updateVisibility();
  }

  updateVisibility() {
    this.contentTargets.forEach((content) => {
      const values = content.dataset.value.split(",").map((v) => v.trim());
      const visible = values.includes(this.selectedValue);
      content.style.display = visible ? "block" : "none";

      content.querySelectorAll("input, textarea, select").forEach((el) => {
        if (visible) {
          if (el.dataset.wasRequired === "true") {
            el.required = true;
            delete el.dataset.wasRequired;
          }
        } else if (el.required) {
          el.dataset.wasRequired = "true";
          el.required = false;
        }
      });

      content.querySelectorAll('[data-controller~="select"]').forEach((el) => {
        if (visible) {
          if (el.dataset.wasSelectRequired === "true") {
            el.dataset.selectRequiredFieldValue = "true";
            delete el.dataset.wasSelectRequired;
          }
        } else if (el.dataset.selectRequiredFieldValue === "true") {
          el.dataset.wasSelectRequired = "true";
          el.dataset.selectRequiredFieldValue = "false";
        }
      });

      if (visible) {
        content.querySelectorAll('[data-controller~="radio-toggle"]').forEach((el) => {
          const nested = this.application.getControllerForElementAndIdentifier(
            el,
            "radio-toggle",
          );
          nested?.updateVisibility();
        });
      }
    });
  }

  selectOption(event) {
    this.selectedValue = event.target.value;
    this.updateVisibility();
  }
}
